module.exports = __webpack_public_path__ + "static/tshqthemes-642256ca1d1969795b25693246da50ed.jpg";